import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { validators as AppValidators } from '../../../../_common/application/ts/validators';
import { IDataQuery } from './Interfaces';

import { bandsHaveCyclicRefs } from '../../../../_common/platform/tsx/GridBandField';
import { NONE } from '../../../../_common/platform/ts/ConfigurationConstants';

const NUMBERS_AND_LETTERS_REGEXP = /^(auto|0)$|^[+]?[0-9]+.?([0-9]+)?(px|em|ex|%|in|cm|mm|pt|pc)$/;

export var length = {
    pixel_percent: function (value) {
        if (!NUMBERS_AND_LETTERS_REGEXP.test(value)) {
            return ['Should contain positive numbers and letters'];
        }
    }
};

//LL: 25.05.21
export function validateBands(value: IDataQuery) {
    if (value != null) {
        const bands = value.bands;

        const numberOfBands = bands != null ? bands.length : 0;
        if (numberOfBands === 0) {
            return null;
        }

        let hasCyclicRefs = bandsHaveCyclicRefs(bands);

        if (hasCyclicRefs) {
            return ['Bands have cyclic references'];
        }

        return null;
    }

    return null;
}

export function validateGroupingAttributes(value: IDataQuery) {
    if (value != null) {
        const attrQueries = value.attrQuery;

        const numberOfAttributes = attrQueries != null ? attrQueries.length : 0;
        if (numberOfAttributes === 0) {
            return null;
        }

        if (value.endlessScrolling === true) {
            const attributeWithSortingExists = _.some(value.attrQuery, (attr) => {
                return attr.sort != null && attr.sort !== NONE;
            });

            if (!attributeWithSortingExists) {
                return ['When Endless Scrolling is on, at least one Attribute must be sorted'];
            }
        }

        return AppValidators.attributesParameterField.validateGroupingAttributes(value);
    }

    return null;
}

//EVG 02.03.22:
// This validator is wrong in many ways:
// 1) Flags like 'defAttrAbsent' must not be stored in configuration.
// 2) It is used in KPI and Grid only, but it looks it shold be for all.
// 3) The same copy is for KPI.
// It should be implemented properly if needed.
// export function validateNoDefaultAttribute(value: IDataQuery) {
//     let retValue = null;

//     if (value != null) {
//         const attrQueries = value.attrQuery;

//         _.each(attrQueries, (attr) => {
//             if (
//                 attr.attribute !== '@expression' &&
//                 attr.aggregateGroup != 'count' &&
//                 attr.type === 'e' &&
//                 attr.defAttrAbsent === true
//             ) {
//                 retValue = 'Selected entity ' + attr.attribute + ' has not default Attribute';
//             }
//         });
//     }
//     return retValue;
// }

export function validateDataLimit(value: IDataQuery) {
    if (value != null) {
        if (value.endlessScrolling === true && value.limit < 100) {
            return ['When Endless Scrolling is on, the amount of records to retch must be at least 100'];
        } else {
            return null;
        }
    }

    return null;
}

export function fix(value: IDataQuery, widgetData: any, glob: IGlob): IDataQuery {
    if (value.endlessScrolling === true) {
        // if (value.limit < 100) {
        //     glob.AppActions.showNotification_Warning(
        //         'Erros in "' + (widgetData.name || '') + '" widget configuration.<br/><br/>\n' +
        //         'When Endless Scrolling is on, the amount of rows to fetch must be equal or more than 100.<br/>\n' +
        //         'This parameter is changed to do not block widget execution.<br/>\n' +
        //         'Please, verify and fix widget configuration',
        //         null,
        //         {
        //             manualDestroy: true
        //         }
        //     );

        //     var newval = $.extend(
        //         true,
        //         {},
        //         value,
        //         {
        //             limit: 100
        //         }
        //     )

        //     return newval;

        // }

        let attributeWithSortingExists: boolean = _.some(value.attrQuery, (attr) => {
            return attr.sort != null && attr.sort !== NONE;
        });

        if (!attributeWithSortingExists) {
            glob.AppActions.showNotification_Fail(
                'Erros in "' +
                    (widgetData.name || '') +
                    '" widget configuration.<br/><br/>\n' +
                    'When Endless Scrolling is on, at least one Attribute must be sorted.<br/>\n' +
                    'The "EndlessScrolling" parameter is turned OFF in configuration to do not block widget execution.<br/>\n' +
                    'Please, verify and fix widget configuration',
                null
            );

            return $.extend(true, value, {
                endlessScrolling: false
            });
        } else {
            return value;
        }
    } else {
        return value;
    }
}
